// Services & Types
import {
  dailyDairyService,
} from "../../../../Api/Services/DailyDariyService";

// Constants
import { ACTION_NAMES, SLICE_NAMES } from "../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../constants/error";

// Utilities
import createGenericSlice from "../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../utils/reduxUtils/createServiceAsyncThunk";
import { ICloseDailyDairyServiceResponse } from "../../types";

export const closeDailyDairyThunk = createServiceAsyncThunk<
  ICloseDailyDairyServiceResponse, // Response Type
  { userId: number; date: string } // Payload Type
>(
  ACTION_NAMES.CLOSE_DAILY_DAIRY, // Action name
  ({ userId, date }: { userId: number; date: string }) =>
    dailyDairyService.closeSubmitDairy({ user_id: userId, date }), // API Call
  ERROR_MESSAGES.CLOSE_DAILY_DAIRY_FAILURE // Error Message
);

const closeDailyDairySlice = createGenericSlice<
  ICloseDailyDairyServiceResponse,
  { userId: number; date: string }
>(
  SLICE_NAMES.CLOSE_DAILY_DAIRY_SLICE, //Slice Name
  closeDailyDairyThunk // Async Thunk
);

// Export actions to be used in components for resetting error and details
export const {
  clearError: clearCloseDailyDairyError,
  clearSuccessMessage: clearCloseDailyDairySuccess,
} = closeDailyDairySlice.actions;

// Export the reducer to be included in the Redux store
export default closeDailyDairySlice.reducer;
